/**
 * Wrappers nativos (Capacitor) de permissão de câmera/microfone.
 *
 * Único lugar autorizado a importar os plugins `@capacitor/camera` e
 * `capacitor-voice-recorder` (regra eslint `synap/no-capacitor-outside-platform`).
 * A orquestração de priming vive em `@/shared/lib/permissions/useDevicePermissionRequest`.
 */

/** Estado atual da permissão de câmera no nativo (string do plugin) ou undefined. */
export async function nativeCameraPermissionState(): Promise<string | undefined> {
  const { Camera } = await import('@capacitor/camera')
  const res = await Camera.checkPermissions()
  return res.camera
}

/** Solicita a permissão de câmera no nativo; retorna o estado resultante. */
export async function nativeRequestCameraPermission(): Promise<string | undefined> {
  const { Camera } = await import('@capacitor/camera')
  const res = await Camera.requestPermissions({ permissions: ['camera'] })
  return res.camera
}

/** True quando o microfone já está autorizado no nativo. */
export async function nativeHasMicrophonePermission(): Promise<boolean> {
  const { VoiceRecorder } = await import('capacitor-voice-recorder')
  const res = await VoiceRecorder.hasAudioRecordingPermission()
  return res.value === true
}

/** Solicita a permissão de microfone no nativo; true quando concedida. */
export async function nativeRequestMicrophonePermission(): Promise<boolean> {
  const { VoiceRecorder } = await import('capacitor-voice-recorder')
  const res = await VoiceRecorder.requestAudioRecordingPermission()
  return res.value === true
}
